import { Injectable, Inject } from 'ng-metadata/core';
import {HttpService} from '../../../../infra/httpRequest/http.service';
import {getInstitutionCode, getInstitutionId} from '../../../../appConfig/appConfigForward';
import { HighlightService } from '../../../../infra/highlight.service';
import { NgrsService } from '../ngrs.service';

const get= require('lodash/get');

@Injectable()
export class PhysicalBestOfferService {
    private primaBaseUrl:any;
    private primaRequestBaseUrl:any;
    private ilsServices:object={};
    private _mmsid: any;
    private _instId = getInstitutionId();
    private _instCode = getInstitutionCode();    
    constructor (private httpService: HttpService,
                 private ngrsService: NgrsService,
				 @Inject('$translate') private $translate,
                 @Inject('restBaseURLs') private restBaseURLs,
                 @Inject('$http') private $http : ng.IHttpService,
				 @Inject('$q') private $q: ng.IQService) {
                    this.primaBaseUrl = restBaseURLs.bestOfferURL;
                    this.primaRequestBaseUrl = restBaseURLs.ngrsCreateBorrowingRequestURL;
					this.ilsServices = {
						    '/bestoffer/physical': {
							'path': this.primaBaseUrl,        
							'method': 'GET'
                        } , 
                             '/bestoffer/borrowingrequest': {
                            'path': this.primaRequestBaseUrl,        
                            'method': 'POST'                            
                        }
                     }; 

	}


    private resquestInProgress:Object = {};
    private _bestOffer:any;

	    
    public getbestOffer(mmsid){
		let params = {
			mmsid: mmsid,
            instId: this._instId,
            instCode:this._instCode
        };
        
        return this.makeIlsRequest('/bestoffer/physical',params);
   }

    public getServices(){
        return this.ilsServices;
	}
	
	makeIlsRequest(serviceName: string, params: Object){
        if(!params){
            params= {};
        }
        let ngrsService = this.ilsServices[serviceName];
        this.resquestInProgress[serviceName] = true;

        return this.httpService.call(ngrsService.method, ngrsService.path, params)
            .then(
                (response)=> {
                    return this.ilsRequestSuccess(response);
                },
                (error)=>{
                    return this.ilsRequestFailure(error, serviceName, params);
                }
            ).finally( () =>
                this.resquestInProgress[serviceName] = false
            );
    }
    
	get requestInProgress(){
        return this.resquestInProgress || false;
    }

    private ilsRequestSuccess(response){
        return response;
    }

    private ilsRequestFailure(reason, serviceName, params) {
        console.error(reason, serviceName);
        return reason;
    }

    public getBestOffer(): any {
        return this._bestOffer;
    }    

    public setBestOffer(value: any){
        this._bestOffer = value;
    }     

    public createBorrowingRequest(note:String,location:String,dueDate:String,item:Object,bestOffer:Object) {
        let params = {
            supplyTime:bestOffer.supplyTime,
            loanPeriod:bestOffer.loanPeriod,
            cost:bestOffer.cost,
            allowRenewal:bestOffer.allowRenewal,
            supportRush:bestOffer.supportRush,
            memberId:bestOffer.memberId,
            policyId:bestOffer.policyId,
            title: get(item ,'pnx.display.title'),
            format: this.calculateFormat(item),
            availableLenderMmsId:bestOffer.availableLenderMmsId,
            lenderMemberId:bestOffer.lenderMemberId,
            lenderMemberName:bestOffer.lenderMemberName,
            lenderInstitutionId: bestOffer.lenderInstitutionId,
            localMmsId:get(item,'pnx.control.sourcerecordid'),            
            requesterNote:note,
            pickUpLocation:location,
            dueDate:dueDate
        };           
        return this.makeIlsRequest('/bestoffer/borrowingrequest',params);
    }    

    private calculateFormat(item:Object):string{
        let primoFormat = get(item,'pnx.addata.format');
        if(primoFormat[0] === 'book'){
            return "PHYSICAL";
        }else{
            return "PHYSICAL";
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/physicalBestOffer/physicalBestOffer.service.ts